import {accessControlEnvironment} from "@/environments.js";

export function accessControlUrl(path) {
  return `https://${accessControlEnvironment}/api/v2/webauthn${path}`;
}
